<template>
  <div id="xero-page">
    <truncate-xero-ids-button />
    <h2>Xero Integration</h2>
    <div class="xero-actions">
      <el-button
        v-if="!connected"
        type="primary"
        size="mini"
        @click="connect_xero"
      >
        Connect to Xero
      </el-button>
      <xero-export v-if="connected" />
    </div>
    <xero-export-log ref="xero_log" />
    <hr>
    <xero-contacts
      v-show="!selected_contact"
      :connected="connected"
      @view-invoices="open_invoices"
      @view-payments="open_payments"
      @view-bills="open_bills"
      @view-credit-notes="open_credit_notes"
    />

    <div v-if="selected_contact">
      <el-button
        size="mini"
        @click="back_to_contacts"
      >
        Back to Contacts
      </el-button>

      <h3>{{ selected_contact.name }}</h3>
      <xero-action-buttons
        :active-tab="active_tab"
        @set-tab="setActiveTab"
      />
      <xero-invoices
        v-if="active_tab === 'invoices'"
        :contact="selected_contact"
      />
      <xero-payments
        v-if="active_tab === 'payments'"
        :contact="selected_contact"
      />
      <xero-bills
        v-if="active_tab === 'bills'"
        :contact="selected_contact"
      />
      <xero-credit-notes
        v-if="active_tab === 'credit_notes'"
        :contact="selected_contact"
      />
    </div>
  </div>
</template>

<script>
import { xero_authorize } from '../../api/xero';
import XeroContacts from './XeroContacts.vue';
import XeroInvoices from './XeroInvoices.vue';
import XeroPayments from './XeroPayments.vue';
import XeroBills from './XeroBills.vue';
import XeroCreditNotes from './XeroCreditNotes.vue';
import XeroActionButtons from './XeroActionButtons.vue';
import XeroExport from './XeroExport.vue';
import TruncateXeroIdsButton from './TruncateXeroIdsButton.vue';
import XeroExportLog from './XeroExportLog.vue';

export default {
  name: 'XeroPage',
  components: { XeroContacts, XeroInvoices, XeroPayments, XeroBills,
    XeroCreditNotes, XeroActionButtons, XeroExport, TruncateXeroIdsButton, XeroExportLog  },
  data() {
    return {
      connected: false,
      selected_contact: null,
      active_tab: null,
      loading: false
    };
  },
  mounted() {
    if (this.$route.query.connected === 'true') {
      this.connected = true;
    }
    this.$root.$on('connect-xero-cable', () => {
      const logComponent = this.$refs.xero_log;
      if (logComponent) logComponent.connectToCable();
    });
  },
  methods: {
    setActiveTab(tab) {
      this.active_tab = tab;
    },
    open_invoices(contact) {
      this.selected_contact = contact;
      this.active_tab = 'invoices';
    },
    open_payments(contact) {
      this.selected_contact = contact;
      this.active_tab = 'payments';
    },
    open_bills(contact) {
      this.selected_contact = contact;
      this.active_tab = 'bills';
    },
    open_credit_notes(contact) {
      this.selected_contact = contact;
      this.active_tab = 'credit_notes';
    },
    back_to_contacts() {
      this.selected_contact = null;
      this.active_tab = null;
    },
    async connect_xero() {
      try {
        const res = await xero_authorize(this);
        window.location.assign(res.data.url);
      } catch (err) {
        console.error('Failed to authorize with Xero', err);
      }
    }
  }
};
</script>
<style scoped>
.xero-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.xero-actions > * {
  display: inline-flex;
  align-items: center;
}
</style>
